import React from 'react';

const Notfound = () => {
    return (
        <div>
           <div className='mx-12'>
            <img className='mx-auto w-100' src="https://i.ibb.co/Xxm1h82/404.webp" alt="" />
        </div> 
        </div>
    );
};

export default Notfound;